export const Roles = {
  Admin: 'admin',
  User: 'user',
};

export const PdfWorkerSrc = "https://unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs" // OR  http://lms.manthanapp.com/pdf.worker.min.mjs
